import CryptoJS from 'crypto-js';
import Keys from '../keys'

export default {
    setAuthentication: (state: any, payload: string): void => {
        state.token = payload;

        if(payload.length){
            //localStorage.setItem('tkn', payload);

            const length = payload.length;
            const segmentLength = Math.ceil(length / 4);
            const segments = [];
            for (let i = 0; i < length; i += segmentLength) {
                segments.push(payload.slice(i, i + segmentLength));
            }
            //----------------------------------------------------
            const x_token = CryptoJS.AES.encrypt(segments[0], Keys.state.public).toString();
            const x_access= CryptoJS.AES.encrypt(segments[1], Keys.state.public).toString();
            const x_keys  = CryptoJS.AES.encrypt(segments[2], Keys.state.public).toString();
            const x_public= CryptoJS.AES.encrypt(segments[3], Keys.state.public).toString();
            //----------------------------------------------------
            localStorage.setItem('x_token',   x_token   ? x_token   : "" );
            localStorage.setItem('x_access',  x_access  ? x_access  : "" );
            localStorage.setItem('x_keys',    x_keys    ? x_keys    : "" );
            localStorage.setItem('x_public',  x_public  ? x_public  : "" );
        }
    }
};
